export default {"src":"/_next/static/media/ping.64f2c7ed.svg","height":16,"width":16};